<template>
  <ubi-panel class="block">
    <h1>{{$t('prompt.instructionLibrary')}}</h1>
    <el-table
        :data="getLibrariePrompt"
        style="width: 100%">
      <el-table-column width="100">
        <template #header>
            <span class="mr-1">{{$t('prompt.selected')}}</span>
            <el-tooltip placement="top-start" :content="$t('prompt.instructionPromptByDefault')">
              <em class="el-icon-question"></em>
            </el-tooltip>
        </template>
        <template slot-scope="scope">
          <el-checkbox :value="isSelected(scope.row)" @change="handleSelection(scope.row)" :disabled="scope.row.reseau !== null"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column
          prop="titre"
          :label="$t('prompt.instructionTitle')"
          width="160"
          show-overflow-tooltip
      ></el-table-column>
      <el-table-column
          fixed="right"
          label="Actions"
          width="180">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="viewDetailsPrompt(scope.$index, getLibrariePrompt)">
            <el-tooltip placement="top-start" :content="$t('prompt.preview')">
              <i class="el-icon-view"></i>
            </el-tooltip>
          </el-button>
          <el-button type="primary" size="mini" @click="viewEditPrompt(scope.$index, getLibrariePrompt)" v-if="scope.row.reseau === null">
            <el-tooltip placement="top-start" :content="$t('prompt.edit')">
              <i class="el-icon-edit"></i>
            </el-tooltip>
          </el-button>
          <el-button type="danger" size="mini" @click="deletePrompt(scope.$index, getLibrariePrompt)" v-if="scope.row.reseau === null">
            <el-tooltip placement="top-start" :content="$t('prompt.trash')">
              <i class="el-icon-delete"></i>
            </el-tooltip>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row :gutter="20" class="mt-3">
      <el-col :span="12" :offset="8">
        <el-button type="primary" size="medium" @click="viewCreatePrompt">{{$t('prompt.defineYourInstructions')}}</el-button>
      </el-col>
    </el-row>
    <el-row :gutter="24" class="mt-3">
      <el-col :span="12" :offset="8">
        <el-pagination
            v-if="getAllCountPrompts.length > 10"
            @current-change="handleCurrentChange"
            background
            :current-page="currentPage"
            :page-size="pageSize"
            :total="getAllCountPrompts.length"
            layout="prev, pager, next"
        >
        </el-pagination>
      </el-col>
    </el-row>
  </ubi-panel>
</template>

<style scoped>

</style>
<script>
import UbiPanel from '@/components/Panel.vue'
import { $t } from '@/i18n'
import { CREATE, DELETE, EDIT, VIEW } from '@/helpers/constantes/promptConstants'
import { mapGetters } from 'vuex'
export default {
  name: 'LibraryPrompt',
  components: { UbiPanel },
  data () {
    return {
      currentPage: 1,
      pageSize: 10,
      totalItems: 100,
      selectedRow: null
    }
  },
  computed: {
    ...mapGetters('promptLibraries', ['getPromptSimulate']),
    ...mapGetters(['getSitimmoUser']),
    getLibrariePrompt () {
      const prompts = this.$store.getters['promptLibraries/getLibrariePrompt']
      const start = (this.currentPage - 1) * this.pageSize
      const end = this.currentPage * this.pageSize
      return prompts.slice(start, end)
    },
    getAllCountPrompts () {
      return this.$store.getters['promptLibraries/getLibrariePrompt']
    }
  },
  methods: {
    handleCurrentChange (page) {
      this.currentPage = page
    },
    viewCreatePrompt () {
      this.$router.push({ path: this.$route.path, query: { action: CREATE } })
      this.$store.commit('promptLibraries/resetPrompt')
    },
    viewDetailsPrompt (index, librarie) {
      this.$router.push({ path: this.$route.path, query: { action: VIEW } })
      this.$store.commit('promptLibraries/setMode', 'PROMPT_ID')
      this.$store.commit('promptLibraries/setPrompt', librarie[index])
      this.$store.dispatch('promptLibraries/callSimulate')
    },
    viewEditPrompt (index, librarie) {
      this.$router.push({ path: this.$route.path, query: { action: EDIT } })
      this.$store.commit('promptLibraries/setMode', 'PROMPT_ID')
      console.log(librarie[index])
      this.$store.commit('promptLibraries/setPrompt', librarie[index])
      this.$store.dispatch('promptLibraries/callSimulate')
    },
    deletePrompt (index, librarie) {
      this.$router.push({ path: this.$route.path, query: { action: DELETE } })
      const prompt = librarie[index]
      this.$confirm($t('prompt.infoDeletingPrompt', { titre: prompt.titre }), $t('prompt.deletePrompt'), {
        confirmButtonText: $t('prompt.validate'),
        cancelButtonText: $t('prompt.cancel'),
        type: 'info'
      }).then(() => {
        try {
          this.$store.dispatch('promptLibraries/deletePrompt', librarie[index])
          this.$message({
            type: 'success',
            message: $t('prompt.deletedSuccess')
          })
          this.$store.commit('promptLibraries/resetPrompt')
        } catch (error) {
          this.$message({
            type: 'error',
            message: $t('prompt.deletedFailed')
          })
        }
      }).finally(() => {
        this.$router.push({ path: this.$route.path, query: { action: CREATE } })
        this.handleCurrentChange(1)
        this.totalItems = this.getAllCountPrompts.length
      })
    },
    isSelected (row) {
      return row.defaut === true
    },
    handleSelection (row) {
      if (row.defaut === true) {
        return
      }
      console.log(row)
      this.$store.commit('promptLibraries/setPrompt', row)
      this.$store.dispatch('promptLibraries/updatePromptDefault', row)
      this.selectedRow = row
    }
  },
  mounted () {
    this.$store.dispatch('promptLibraries/loadPrompts')
    this.totalItems = this.getAllCountPrompts.length
    const defaultPrompts = this.getLibrariePrompt.filter((item) => item.defaut === true)
    this.selectedRow = defaultPrompts.length > 0 ? defaultPrompts[0] : null
  }
}
</script>
<style scoped>
.title-library{
  width: fit-content;
  background: #C21F39;
  padding: 5px;
}
</style>
